import React from 'react';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import Form from '$/components/ui/Form';
import UrlInput from '$/components/ui/Input/Basics/UrlInput';
import { Popup } from '$/components/ui/Popup';

export const HandoutSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = ({ mentions }) => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <>
            <Form.FieldLabel
              title={
                <div className='flex'>
                  URL linked to button{' '}
                  <Popup
                    className='ml-1/2e'
                    content={
                      <span>
                        URL will open in a new browser tab when attendees click the button.
                      </span>
                    }
                    popperModifiers={[
                      {
                        name: 'preventOverflow',
                        enabled: false,
                        options: {
                          boundary: 'window',
                        },
                      },
                    ]}
                  />
                </div>
              }
            />
            <Form.Field
              name='details.link'
              className='mb-0'
              component={<UrlInput placeholder='Enter URL' mentions={mentions} />}
            />
          </>
        ),
      },
    },
  ];
};
